<template>
  <div class="main">
    <Header/>
    <div class="content">
      <Logo subTitle="Captura De Solicitud De Prestamos" description="" />
      <PreRequestLoan/>
    </div>
  </div>
</template>

<script>

import Header from '@/components/Header/Header.vue'
import PreRequestLoan from '@/components/PreRequestLoan/PreRequestLoan.vue'
import Logo from '@/components/PreRequestLoan/Logo.vue'

export default {
  data() {
    return {

    }
  },
  name: "PreRequestLoanView",
  components: {
    Header,
    PreRequestLoan,
    Logo
  }
}
</script>

<style scoped>
.main {
  @apply grid grid-cols-1 gap-4;
}
.content {
  padding:30px;
}
</style>
